import i18n from '@/plugins/i18n'

export default [
    {
        path: '/' + i18n.t('routes.category.index'),
        name: 'category.index',
        component: () =>
            import(
                /* webpackChunkName: "categories" */ '@/views/categories/Index.vue'
            ),
        meta: {
            requiredAuth: true,
            breadcrumb: [
                {
                    text: i18n.t('routes.category.breadcrumb.index'),
                    to: null,
                    disable: true,
                },
            ],
        },
    },
    {
        path: '/' + i18n.t('routes.category.create'),
        name: 'category.create',
        component: () =>
            import(
                /* webpackChunkName: "categories" */ '@/views/categories/Create.vue'
            ),
        meta: {
            requiredAuth: true,
            breadcrumb: [
                {
                    text: i18n.t('routes.category.breadcrumb.index'),
                    to: { name: 'category.index' },
                    disable: false,
                },
                {
                    text: i18n.t('routes.breadcrumb.create'),
                    to: null,
                    disable: true,
                },
            ],
        },
        props: true,
    },
    {
        path: '/' + i18n.t('routes.category.edit') + '/:id',
        name: 'category.edit',
        component: () =>
            import(
                /* webpackChunkName: "categories" */ '@/views/categories/Edit.vue'
            ),
        meta: {
            requiredAuth: true,
            breadcrumb: [
                {
                    text: i18n.t('routes.category.breadcrumb.index'),
                    to: { name: 'category.index' },
                    disable: false,
                },
                {
                    text: i18n.t('routes.breadcrumb.edit'),
                    to: null,
                    disable: true,
                },
            ],
        },
        props: true,
    },
]
